import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BankDialog = _resolveComponent("BankDialog");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_dialog = _resolveComponent("q-dialog");
    const _component_BranchDialog = _resolveComponent("BranchDialog");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_q_dialog, {
            modelValue: _ctx.isBankDialog,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.isBankDialog) = $event)),
            persistent: ""
        }, {
            default: _withCtx(() => [
                _createVNode(_component_q_card, { style: { "width": "100%", "min-height": "430px", "z-index": "2000" } }, {
                    default: _withCtx(() => [
                        _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => [
                                _createVNode(_component_BankDialog, {
                                    onClose: _ctx.closeBankDialogs,
                                    onSelect: _ctx.handleBankSelect
                                }, null, 8, ["onClose", "onSelect"])
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                })
            ]),
            _: 1
        }, 8, ["modelValue"]),
        (_ctx.selectedBank)
            ? (_openBlock(), _createBlock(_component_q_dialog, {
                key: 0,
                modelValue: _ctx.isBranchDialog,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.isBranchDialog) = $event)),
                persistent: ""
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_q_card, { style: { "width": "100%", "min-height": "430px" } }, {
                        default: _withCtx(() => [
                            _createVNode(_component_q_card_section, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_BranchDialog, {
                                        bank: _ctx.selectedBank,
                                        onClose: _ctx.closeBankDialogs,
                                        onSelect: _ctx.handleBranchSelect,
                                        onBack: _ctx.bankDialogReturn
                                    }, null, 8, ["bank", "onClose", "onSelect", "onBack"])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }, 8, ["modelValue"]))
            : _createCommentVNode("", true)
    ], 64));
}
